import {
  VIEW_USER,
  VIEW_USER_SUCCESS,
  VIEW_USER_ERROR,
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

const DEFAULT_STATE = {
  loading: false,
  error: null,
  data: null,
  id: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case VIEW_USER:
      return {
        ...state,
        loading: true,
        error: null,
        data: null,
        id: null,
      }
    case VIEW_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
        id: action.payload ? action.payload._id : null,
      }
    case VIEW_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: null,
        id: null,
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/viewingUserReducer.js